// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://grandbazzar-back.onrender.com/'
});

export default axiosInstance;

export const weburl = 'https://grandbazzar-back.onrender.com/';
export const shopurl = 'https://admingrandbazzar.spacedeco.in/';
export const mainurl = 'https://admingrandbazzar.spacedeco.in/';
